(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-image-multiple"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('load', function() {
      const swiper = new Swiper(".before-after-swiper", { // Optional parameters
        slidesPerView: "auto",
        autoplay: { enabled: false},
        loop: true,
        a11y: { enabled: false },
        centeredSlides: true,
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        spaceBetween: 40,
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-swiper"] && !window.DesignMode) return;
  try {
    
  //サムネイル
var sliderThumbnail = new Swiper('.slider-thumbnail', {
  slidesPerView: 4,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

//スライダー
var slider = new Swiper('.slider', {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: sliderThumbnail
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--category--collection-list-swiper"] && !window.DesignMode) return;
  try {
    





  var slider = new Swiper('.mySwiper2', {
     slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
     thumbs: {
        swiper: swiper,
       thumbsContainerClass: 'swiper-thumbs',
       multipleActiveThumbs: true,
       
      },
    slideToClickedSlide: true,
    
  });

   var swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--category--collection-list"] && !window.DesignMode) return;
  try {
    

  var swiperContainer = document.querySelector('.swiper-container');
  var blockCount = parseInt(swiperContainer.getAttribute('data-blocks'));

   for (var i = 1; i <= blockCount; i++) {

          var swiper = new Swiper('.thumb-'+ i, {
              spaceBetween: 10,
              slidesPerView: 3,
              freeMode: true,
              watchSlidesProgress: true,
             on: {
        init: function() {
          // Erstes Bild ausblenden
          var firstSlide = this.slides[0];
          if (firstSlide) {
            firstSlide.classList.add('swiper-slide-hidden');
          }
        }
      }
            });
     
          var slider = new Swiper('.swiper-'+ i, {
              slidesPerView: 1,
              spaceBetween: 10,
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
              thumbs: {
                  swiper: swiper,
                  thumbsContainerClass: 'swiper-thumbs',
                  multipleActiveThumbs: true,
               
              },
          });

}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--category--collection-swiper-old"] && !window.DesignMode) return;
  try {
    





  var slider = new Swiper('.mySwiper2', {
     slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
     thumbs: {
        swiper: swiper,
       thumbsContainerClass: 'swiper-thumbs',
       multipleActiveThumbs: true,
       
      },
    slideToClickedSlide: true,
    
  });

   var swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });

  

  } catch(e) { console.error(e); }
})();
})();
